<template>
    <div>
        <el-card>
            <el-page-header class="align-items-start mb-3" @back="goBack">
                <div slot="content" class="d-flex flex-wrap align-items-start justify-content-between">
                    <div class="d-flex flex-column">
                      <h5 class="mb-1">{{ getJuridicPerson.razao_social }}</h5>
                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <small v-if="getJuridicPerson.cnpj"><strong>CNPJ: </strong>{{ getJuridicPerson.cnpj }}</small>
                      </div>
                    </div>

                    <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                      <el-tag
                        v-if="prospect.tipo_cadastro"
                        class="rounded-pill"
                        :type="prospect.tipo_cadastro == 'NOVO'
                            ? 'success' 
                            : (prospect.status == 'REATIVACAO' 
                                ? 'primary'
                                : 'warning'
                              )"
                      >
                        <i :class="prospect.tipo_cadastro == 'NOVO'
                          ? 'el-icon-finished' 
                          : (prospect.status == 'REATIVACAO' 
                              ? 'el-icon-refresh'
                              : 'el-icon-connection'
                            )"
                        ></i>
                        {{ prospect.tipo_cadastro }}
                      </el-tag>

                      <el-divider direction="vertical"></el-divider>

                      <el-tag
                          v-if="prospect.status"
                          :type="prospect.status == 'ATIVO'
                              ? 'success' 
                              : (prospect.status == 'DIGITADO' 
                                ? 'primary'
                                : (prospect.status == 'PRE_CADASTRO' 
                                    ? 'info'
                                    : (prospect.status == 'PENDENTE' 
                                      ? 'warning'
                                      : 'danger' 
                                    )
                                  )
                                )"
                      >
                        {{ prospect.status }}
                      </el-tag>

                      <el-tag v-if="prospect.created_at" type="info">
                        <div class="d-flex align-items-center">
                          <i class="el-icon-time mr-2"></i>
                          {{ formatDate(prospect.created_at) }}
                        </div>
                      </el-tag>
                    </div>
                </div>
            </el-page-header>

            <!-- content -->
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane name="first">
                  <span slot="label">
                      <i class="el-icon-office-building"></i>
                      <span class="ml-1">Empresa</span>
                  </span>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-descriptions title="Dados" :column="6" size="mini" :border="true" class="my-3">
                          <!-- Razao Social -->
                          <el-descriptions-item :span="6">
                              <template slot="label">Razão Social</template>
                              <div class="d-flex align-items-center justify-content-between">
                                <span v-if="getJuridicPerson.razao_social">{{ getJuridicPerson.razao_social }}</span>
                                <span v-else>-</span>
                              </div>
                          </el-descriptions-item>
    
                          <!-- Nome Fantasia -->
                          <el-descriptions-item :span="6">
                              <template slot="label">Nome Fantasia</template>
                              <div class="d-flex align-items-center justify-content-between">
                                <span v-if="getJuridicPerson.nome_fantasia">{{ getJuridicPerson.nome_fantasia }}</span>
                                <span v-else>-</span>
                              </div>
                          </el-descriptions-item>
    
                          <!-- CPF -->
                          <el-descriptions-item 
                              v-if="getFisicPerson" 
                              :span="6"
                          >
                              <template slot="label">CPF</template>
    
                              <div class="d-flex align-items-center justify-content-between">
                                  <div>
                                      <el-skeleton v-if="isLoading"/>
                                      <span v-else>{{ getFisicPerson.cpf || '-' }}</span>
                                  </div>
                                  <el-button v-if="getFisicPerson.cpf" size="mini" circle @click="copyThis(getFisicPerson.cpf)">
                                      <i class="el-icon-document-copy"></i>
                                  </el-button>
                              </div>
                          </el-descriptions-item>
    
                          <!-- CNPJ -->
                          <el-descriptions-item 
                            v-if="getJuridicPerson" 
                            :span="6"
                          >
                              <template slot="label">CNPJ</template>
                              <div class="d-flex align-items-center justify-content-between">
                                  {{ getJuridicPerson.cnpj || '-' }}
                                  <el-button v-if="getJuridicPerson.cnpj" size="mini" circle @click="copyThis(getJuridicPerson.cnpj)">
                                      <i class="el-icon-document-copy"></i>
                                  </el-button>
                              </div>
                          </el-descriptions-item>
    
                          <!-- Inscricao Estadual -->
                          <el-descriptions-item :span="6">
                            <template slot="label">Inscrição Estadual</template>
                            <span>{{ getJuridicPerson.inscricao_estadual || '-' }}</span>
                          </el-descriptions-item>
    
                          <!-- Cadastro MEI -->
                          <el-descriptions-item :span="3">
                            <template slot="label">Cadastro Mei</template>
                            <el-tag size="mini" :type="getJuridicPerson.cadastro_mei ? 'success' : 'info'">
                              {{ getJuridicPerson.cadastro_mei ? 'Sim' : 'Não' }}
                            </el-tag>
                          </el-descriptions-item>
    
                          <!-- Assinado GOV -->
                          <el-descriptions-item :span="3">
                            <template slot="label">Assinado Gov</template>
                            <el-tag size="mini" :type="getJuridicPerson.assinado_gov ? 'success' : 'info'">
                              {{ getJuridicPerson.assinado_gov ? 'Sim' : 'Não' }}
                            </el-tag>
                          </el-descriptions-item>
                      </el-descriptions>
                    </el-col>

                    <el-col :span="12">
                      <el-descriptions title="Informações de cadastro" :column="6" size="mini" :border="true" class="my-3">
                          <!-- Classe -->
                          <el-descriptions-item :span="6" label="Classe">
                            <el-tag v-if="prospect.classe_distribuidor" size="small" type="primary">{{ prospect.classe_distribuidor }}</el-tag>
                            <el-tag v-else size="small" type="info">Sem atribuição</el-tag>
                          </el-descriptions-item>
    
                          <!-- Centro de Distribuição -->
                          <el-descriptions-item :span="6" label="Centro de Distribuição">
                            <el-tag v-if="cd" size="small" type="success">{{ cd.descricao }}</el-tag>
                            <el-tag v-else size="small" type="info">Sem atribuição</el-tag>
                          </el-descriptions-item>
    
                          <!-- Regioes -->
                          <el-descriptions-item :span="6" label="Regiões">
                            <el-tag v-if="getRegion" size="small" type="info">{{ getRegion.descricao }}</el-tag>
                            <el-tag v-else size="small" type="info">Sem atribuição</el-tag>
                          </el-descriptions-item>
    
                         <!-- Codigo anterior -->
                          <el-descriptions-item v-if="prospect.codigo_anterior" :span="6" label="Código Anterior">
                            <span>{{ prospect.codigo_anterior }}</span>
                          </el-descriptions-item>
                      </el-descriptions>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane name="second">
                  <span slot="label">
                      <i class="el-icon-location-outline"></i> 
                      <span class="ml-1">Endereços</span>
                  </span>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-descriptions title="Endereço principal" :column="4" size="small" :border="true" class="my-3">
                        <template slot="extra">
                          <div v-if="getPrincipalAddress == null">
                            <el-tag size="mini" type="info">Não cadastrado</el-tag>
                          </div>
                        </template>

                          <el-descriptions-item :span="4" label="CEP">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.cep">
                              {{ getPrincipalAddress.cep }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Logradouro">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.logradouro">
                              {{ getPrincipalAddress.logradouro }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Complemento">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.complemento">
                              {{ getPrincipalAddress.complemento }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Bairro">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.bairro">
                              {{ getPrincipalAddress.bairro }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="2" label="Estado">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.cidade && getPrincipalAddress.cidade.estado">
                              {{ getPrincipalAddress.cidade.estado.uf }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="2" label="Cidade">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.cidade">
                              {{ getPrincipalAddress.cidade.nome }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Instruções de Entrega">
                            <span v-if="getPrincipalAddress && getPrincipalAddress.instrucao_entrega">
                              {{ getPrincipalAddress.instrucao_entrega }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>
                      </el-descriptions>
                    </el-col>

                      <el-col :span="12">
                        <el-descriptions title="Endereço de entrega" :column="4" size="small" :border="true" class="my-3">
                          <template slot="extra">
                            <div v-if="getDeliveryAddress == null">
                              <el-tag size="mini" type="info">Não cadastrado</el-tag>
                            </div>
                          </template>

                          <el-descriptions-item :span="4" label="CEP">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.cep">
                              {{ getDeliveryAddress.cep }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Logradouro">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.logradouro">
                              {{ getDeliveryAddress.logradouro }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Complemento">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.complemento">
                              {{ getDeliveryAddress.complemento }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Bairro">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.bairro">
                              {{ getDeliveryAddress.bairro }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="2" label="Estado">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.cidade && getDeliveryAddress.cidade.estado">
                              {{ getDeliveryAddress.cidade.estado.uf }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="2" label="Cidade">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.cidade">
                              {{ getDeliveryAddress.cidade.nome }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>

                          <el-descriptions-item :span="4" label="Instruções de Entrega">
                            <span v-if="getDeliveryAddress && getDeliveryAddress.instrucao_entrega">
                              {{ getDeliveryAddress.instrucao_entrega }}
                            </span>
                            <span v-else>-</span>
                          </el-descriptions-item>
                        </el-descriptions>
                      </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane name="third">
                  <span slot="label">
                    <i class="el-icon-phone-outline"></i> 
                    <span class="ml-1">Contatos</span>
                  </span>

                  <el-col>
                    <el-descriptions
                      v-if="getContacts && getContacts.length > 0"
                      title="Contatos"
                      :column="4"
                      :border="true"
                      class="my-3"
                    >
                      <template slot="extra">
                        <div class="d-flex align-items-center">
                          <el-button
                            size="mini" 
                            type="warning" 
                            plain 
                            title="Consulta manual LEMIT"
                            @click.native.prevent="handleConsultLemit()"
                            :disabled="isLoading"
                          >
                              <i v-if="isLoading" class="el-icon-loading"></i>
                              <i v-else class="el-icon-right"></i>
                              Realizar consulta LEMIT
                          </el-button>
                        </div>
                      </template>
                      <template>
                          <el-descriptions-item 
                            v-for="(contact, index) in getContacts" 
                            :key="contact.id"
                            :span="2"
                          >
                            <template v-if="contact.telefone" slot="label">
                                {{ contact.telefone.tipo == 'F' ? 'Fixo' : 'Celular' }}
                            </template>
                            <template v-else slot="label">Telefone não informado</template>

                            <div v-if="contact.telefone" class="d-flex align-items-center justify-content-between">
                              <h6 class="mb-0">({{ contact.telefone.ddd }}) {{ contact.telefone.numero }}</h6>
                              <div>
                                <el-button v-if="contact.telefone.whatsapp" size="small" type="success" circle :style="{ pointerEvents: 'none', cursor: 'auto' }">
                                  <BIconWhatsapp/>
                                </el-button>
                                <el-button size="small" circle @click="copyThis(`(${contact.ddd})$ {contact.numero}`)">
                                  <i class="el-icon-document-copy"></i>
                                </el-button>
                              </div>
                            </div>
                          </el-descriptions-item>
                      </template>
                    </el-descriptions>
                    <div v-else>
                      <span><strong>Contatos</strong></span>
                      <el-empty description="Nenhuma contato atribuido"></el-empty>
                    </div>
                  </el-col>
                </el-tab-pane>

                <el-tab-pane name="fourth">
                  <span slot="label">
                      <i class="el-icon-setting"></i> 
                      <span class="ml-1">Configurações</span>
                  </span>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-descriptions title="Financeiro" :column="4" size="small" :border="true">
                        <el-descriptions-item :span="4" label="Via de Pagamento">
                          <span v-if="prospect.pagamento">{{ prospect.pagamento }}</span>
                          <span v-else>-</span>
                        </el-descriptions-item>

                        <el-descriptions-item :span="4" label="Limite de Crédito">
                          <span v-if="prospect.limite_credito">{{ prospect.limite_credito }}</span>
                          <span v-else>-</span>
                        </el-descriptions-item>

                        <el-descriptions-item :span="4" label="Prazo p/ pagamento">
                          <span v-if="prospect.prazo_pagamento != null">{{ prospect.prazo_pagamento }}</span>
                          <span v-else>-</span>
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-col>

                    <el-col :span="12">
                      <!-- Kits -->
                      <div class="pt-1 d-flex align-items-center justify-content-between mb-3">
                        <h6 class="font-weight-bold mb-0">Kits</h6>
                        <div>
                          <el-tag
                            v-for="kit in getKits"
                            :key="kit.text"
                            class="mr-1"
                            size="small"
                            :type="kit.value ? 'primary' : 'info'"
                            :style="{ opacity: kit.value ? '1' : '0.5' }"
                          >
                            <i v-if="kit.value" class="el-icon-circle-check"/>
                            {{ kit.text }}
                          </el-tag>
                        </div>
                      </div>

                      <!-- Revendedoras -->
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <h6 class="font-weight-bold mb-0">Revendedoras</h6>
                        <el-tag type="primary" size="small">{{ prospect.qtd_revendedoras }}</el-tag>
                      </div>

                      <!-- Catalogos -->
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <h6 class="font-weight-bold mb-0">Catálogos</h6>
                        <el-tag type="primary" size="small">{{ prospect.qtd_catalogo }}</el-tag>
                      </div>

                      <!-- Cadastro Matriz -->
                      <div class="d-flex align-items-center justify-content-between">
                        <h6 class="font-weight-bold mb-0">Código Cadastro Matriz</h6>
                        <el-tag v-if="getMatriz" type="primary" size="small">{{ getMatriz.codigo }}</el-tag>
                        <el-tag v-else="getMatriz" type="warning" size="small">Sem associação</el-tag>
                      </div>
                    </el-col>

                  </el-row>
                </el-tab-pane>

                <el-tab-pane name="fifth">
                  <span slot="label">
                    <i class="el-icon-folder"></i> 
                    <span class="ml-1">Anexos</span>
                  </span>

                  <div>
                    <Anexos :prospect="prospect"/>
                  </div>
                </el-tab-pane>
            </el-tabs>

            <el-tabs class="mt-3" tab-position="left" v-model="activeInfo">
              <el-tab-pane name="second">
                <span slot="label">
                    <i class="el-icon-chat-line-square"></i>
                    <span class="ml-1">Observações</span>
                </span>

                <div class="rounded border p-3">
                  <el-timeline v-if="getObservations && getObservations.length > 0">
                    <el-timeline-item 
                      v-for="(obs, index) in getObservations"
                      :timestamp="obs.created_at" 
                      placement="top"
                      :key="obs.id"
                      color="#0bbd87"
                    >
                      <el-card>
                        <p class="mb-0" :style="{ fontSize: '14px' }">{{ obs.observacao }}</p>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>

                  <el-empty v-else description="Nenhuma observação encontrada"></el-empty>
                </div>
              </el-tab-pane>

              <el-tab-pane name="first">
                <span slot="label">
                  <i class="el-icon-timer"></i>
                  <span class="ml-1">Histórico</span>
                </span>

                <div class="rounded border p-3">

                  <el-timeline v-if="getHistoric && getHistoric.length > 0">
                    <el-timeline-item 
                      v-for="(historic, index) in getHistoric"
                      :key="historic.id"
                      :timestamp="formatDate(historic.created_at, true)"
                      placement="top"
                      :color="historic.origem == 'LEMIT' ? '#e6a23c' : '#0bbd87'"
                    >
                      <el-card class="mb-2">
                        <div class="d-flex align-items-center justify-content-between" :style="{ gap: '12px' }">
                        <div class="flex-grow-1">
                            <span><strong>{{ historic.titulo }}</strong></span>
                          </div>

                          <el-tag :type="typeProspectHistoric(historic.origem)">
                            {{ historic.origem }}
                          </el-tag>
                        </div>

                        <div v-if="historic.origem == 'LEMIT' && historic.destino != 'LEMIT_INVALIDO'" class="d-flex flex-column mt-2">
                          <div class="p-2 rounded d-flex align-items-center justify-content-between" :style="{ border: '1px dashed #dedede', gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '12px' }">
                              <el-tag type="success" class="rounded-circle">
                                <i class="el-icon-phone-outline"></i>
                              </el-tag>

                              <div>
                                <span class="text-muted">Número verificado</span>
                                <h6><strong>{{ maskPhoneNumber(historic.descricao) }}</strong></h6>
                              </div>
                            </div>

                            <el-tag :type="historic.destino == 'LEMIT_CONFIRMADO' ? 'success' : 'danger'" size="small" effect="dark">
                              <span v-if="historic.destino == 'LEMIT_CONFIRMADO'">CONFIRMADO</span>
                              <el-tooltip
                                v-else
                                content="Este número não pode ser verificado via LEMIT, faça uma analíse manual ou realize uma nova consulta"
                                placement="bottom-start"
                                effect="light"
                              >
                                <span>NÃO CONFIRMADO</span>
                              </el-tooltip>
                            </el-tag>
                          </div>
                        </div>
                      </el-card>

                      <div v-if="historic.user" class="d-flex align-items-center justify-content-end" :style="{ gap: '8px' }">
                        <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                          <el-avatar size="small">{{ historic.user.name.charAt(0) }}</el-avatar>
                          <div class="d-flex flex-column">
                            <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ historic.user.name }}</span>
                            <span class="text-muted" :style="{ fontSize: '14px' }">{{ historic.user.email }}</span>
                          </div>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>

                  <el-empty v-else description="Nenhum histórico encontrado"></el-empty>
                </div>
              </el-tab-pane>
            </el-tabs>

            <el-row class="mt-3">
              <el-col>
                <div class="d-flex align-items-center mb-2" :style="{ gap: '8px'}">
                  <i class="el-icon-edit-outline"></i>
                  Atuantes
                </div>
                
                <div class="rounded border p-3">
                  <div class="d-flex flex-column" :style="{ gap: '12px' }">
                    <!-- User -->
                    <div v-if="getUser" class="d-flex align-items-center justify-content-between" :style="{ gap: '8px' }">
                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-avatar size="medium">{{ getUser.name.charAt(0) }}</el-avatar>
                        <div class="d-flex flex-column">
                          <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ getUser.name }}</span>
                          <span class="text-muted" :style="{ fontSize: '14px' }">{{ getUser.email }}</span>
                        </div>
                      </div>
    
                      <el-tag type="success">Criou o prospecto</el-tag>
                    </div>
  
                    <!-- Saler -->
                    <div v-if="getSaler" class="d-flex align-items-center justify-content-between" :style="{ gap: '8px' }">
                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-avatar size="medium">{{ getSaler.nome.charAt(0) }}</el-avatar>
                        <div class="d-flex flex-column">
                          <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ getSaler.nome }}</span>
                        </div>
                      </div>
    
                      <el-tag type="warning">Vendedor</el-tag>
                    </div>
  
                    <!-- CD Indic.-->
                    <div v-if="getCdIndic" class="d-flex align-items-center justify-content-between" :style="{ gap: '8px' }">
                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-avatar size="medium" icon="el-icon-office-building"></el-avatar>
                        <div class="d-flex flex-column">
                          <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ getCdIndic.nome }}</span>
                          <span class="text-muted" :style="{ fontSize: '14px' }">{{ getCdIndic.email }}</span>
                        </div>
                      </div>
    
                      <el-tag type="primary">Distribuidor Indicante</el-tag>
                    </div>
  
                    <!-- Matriz-->
                    <div v-if="getMatriz" class="d-flex align-items-center justify-content-between" :style="{ gap: '8px' }">
                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-avatar size="medium" icon="el-icon-office-building"></el-avatar>
                        <div class="d-flex flex-column">
                          <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ getMatriz.nome }}</span>
                          <span class="text-muted" :style="{ fontSize: '14px' }">{{ getMatriz.email }}</span>
                        </div>
                      </div>
    
                      <el-tag type="warning">Matriz associada</el-tag>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
    // Components
    import { 
      Row,
      Col,
      Card, 
      PageHeader, 
      Tag, 
      Notification, 
      Tabs, 
      TabPane, 
      Loading, 
      Message, 
      Empty,
      Descriptions,
      DescriptionsItem,
      Button,
      Divider,
      Timeline,
      TimelineItem,
      Avatar,
      Tooltip,
    } from 'element-ui';

    import { BIconWhatsapp } from 'bootstrap-vue'

    import Anexos from "../adm_prospecto/partials/Anexos.vue";

    // Utils
    import { copyThis } from "@/util/copyThis.js";
    import { formatDate, maskPhoneNumber } from "@/util/formatters.js";
    
    // Api
    import { ProspectoApi } from "@/api/Prospecto/ProspectoApi.js";
    const prospectoApi = new ProspectoApi();

    export default {
      props: {
          id: {
              type: [String, Number],
              default: null,
              required: true
          },
          prospect: {
            type: [String, Array, Object, null],
            required: true
          },
          cd: {
            type: [String, Array, Object, null],
            required: true
          }
      },
      data() {
        return {
          activeName: 'first',
          activeInfo: 'first',
          isLoading: false,
        }
      },
      methods: {
        async consultLemit() {
          try {
            this.isLoading = true;

            const res = await prospectoApi.manualConsultLemit(this.id);

            Notification.success({
              title: 'Sucesso',
              message: res.msg
            });
          } catch (error) {
            Notification.error({
              title: 'Erro',
              message: 'Não foi possível consultar o LEMIT. Algo inesperado ocorreu!'
            });
          } finally {
            this.isLoading = false;
          }
        },
        async handleConsultLemit() {
          this.$confirm('Deseja realiazar a consulta ao LEMIT?', 'Consultar LEMIT', {
              confirmButtonText: 'Consultar',
              cancelButtonText: 'Cancelar',
          }).then(async () => {
            await this.consultLemit(); 
          })
        },
        goBack() {
          window.location.assign('/adm/prospecto')
        },
        typeProspectHistoric(type) {
          switch(type) {
            case 'LEMIT':
              return 'warning'
            case 'NOVO':
              return 'success'
            default: 
              return 'primary'
          }
        },
        copyThis,
        formatDate,
        maskPhoneNumber
      },
      computed: {
        isAuthorized() {
            return this.$store.getters['user/isAnyRole'](['adm']);
        },  
        getFisicPerson() {
          return this.prospect?.prospecto_empresa?.pessoa_fisica;
        },
        getJuridicPerson() {
          return this.prospect?.prospecto_empresa?.pessoa_juridica;
        },
        getPrincipalAddress() {
          return this.prospect?.prospecto_empresa?.endereco;
        },
        getDeliveryAddress() {
          return this.prospect?.prospecto_empresa?.endereco_entrega;
        },
        getContacts() {
          return this.prospect?.prospecto_empresa?.contatos;
        },
        getObservations() {
          return this.prospect?.observacoes;
        },
        getHistoric() {
          return this.prospect?.historico
        },
        getUser() {
          return this.prospect?.user;
        },
        getRegion() {
          return this.prospect?.regiao;
        },
        getSaler() {
          return this.prospect?.vendedor;
        },
        getCdIndic() {
          return this.prospect?.indicante;
        },
        getKits() {
          const kits = [
            { value: this.prospect?.kit_super_credito, text: 'Super crédito',  },
            { value: this.prospect?.kit_cadastro, text: 'Cadastro' },
            { value: this.prospect?.kit_cadastro_revendedora, text: 'Cadastro revendedora' },
            { value: this.prospect?.kit_farmacia, text: 'Farmácia' },
            { value: this.prospect?.kit_salao, text: 'Salão' },
            { value: this.prospect?.kit_personalizado, text: 'Personalizado' },
          ]

          return kits
        },
        getMatriz() {
          return this.prospect?.matriz;
        },
      },
      components: {
        Anexos,
        BIconWhatsapp,
        [Row.name]: Row,
        [Col.name]: Col,
        [Card.name]: Card,
        [PageHeader.name]: PageHeader,
        [Tag.name]: Tag,
        [Notification.name]: Notification,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane, 
        [Loading.name]: Loading, 
        [Message.name]: Message,
        [Button.name]: Button,
        [Empty.name]: Empty,
        [Descriptions.name]: Descriptions,
        [DescriptionsItem.name]: DescriptionsItem,
        [Divider.name]: Divider,
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
        [Avatar.name]: Avatar,
        [Tooltip.name]: Tooltip,
      }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_prospecto/Show.vue